import { useLocation } from 'react-router';
import * as t from 'io-ts';
import * as O from 'fp-ts/Option';
import * as E from 'fp-ts/Either';
import qs from 'qs';
import { pipe } from 'fp-ts/lib/function';

const intendedPayload = t.type({ intended: t.string });

export const useIntendedPath = () => {
  const location = useLocation();

  return pipe(
    O.fromNullable(location.search),
    O.map((search) => qs.parse(search, { ignoreQueryPrefix: true })),
    E.fromOption(() => null),
    E.chainW(intendedPayload.decode),
    E.map((payload) => payload.intended),
    O.fromEither,
  );
};
